jQuery(document).ready(function () {
    jQuery(window).on('YoastSEO:ready', function () {
        if (typeof CarbonFieldsYoast !== undefined) {
            new CarbonFieldsYoast();
        }
    });
});
